import { SocialMediaPlatform, SocialMediaPreset } from "./resizeSettings";

export type SocialMediaPlatformName = SocialMediaPlatform["name"];
export const socialMediaPresetList: Record<SocialMediaPlatformName, SocialMediaPreset[]> = {
    Facebook: [
        {
            name: "Profile",
            dimension: {
                width: 170,
                height: 170,
            },
        },
        {
            name: "Cover",
            dimension: {
                width: 820,
                height: 312,
            },
        },
        {
            name: "Post",
            dimension: {
                width: 1200,
                height: 900,
            },
        },
        {
            name: "Ad",
            dimension: {
                width: 1280,
                height: 720,
            },
        },
    ],
    Instagram: [
        {
            name: "Profile",
            dimension: {
                width: 110,
                height: 110,
            },
        },
        {
            name: "Post",
            dimension: {
                width: 320,
                height: 320,
            },
        },
        {
            name: "Story",
            dimension: {
                width: 1080,
                height: 1920,
            },
        },
    ],
    Twitter: [
        {
            name: "Profile",
            dimension: {
                width: 400,
                height: 400,
            },
        },
        {
            name: "Header",
            dimension: {
                width: 1500,
                height: 1500,
            },
        },
        {
            name: "Image",
            dimension: {
                width: 1024,
                height: 512,
            },
        },
        {
            name: "Card",
            dimension: {
                width: 1200,
                height: 628,
            },
        },
        {
            name: "Ad",
            dimension: {
                width: 1200,
                height: 675,
            },
        },
    ],
    YouTube: [
        {
            name: "Profile",
            dimension: {
                width: 800,
                height: 800,
            },
        },
        {
            name: "Channel Art",
            dimension: {
                width: 2560,
                height: 1440,
            },
        },
        {
            name: "Thumbnail",
            dimension: {
                width: 1280,
                height: 720,
            },
        },
    ],
};
export const socialMediaPlatformList: Record<SocialMediaPlatformName, SocialMediaPlatform> = {
    Facebook: {
        name: "Facebook",
        preset: socialMediaPresetList["Facebook"][0],
    },
    Instagram: {
        name: "Instagram",
        preset: socialMediaPresetList["Instagram"][0],
    },
    Twitter: {
        name: "Twitter",
        preset: socialMediaPresetList["Twitter"][0],
    },
    YouTube: {
        name: "YouTube",
        preset: socialMediaPresetList["YouTube"][0],
    },
};
